module.exports = "<li class=\"menu-item\" ng-transclude>\n</li>\n"